import PropTypes from "prop-types";
import React from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import Text from "app/components/Text";
import apiActions from "app/utils/apiActions";
import textHelpers from "app/utils/textHelpers";
import { styleSheet, colors, sizes } from "app/utils/styleSheet";
// import { navigationRef } from 'app/utils/RootNavigation';
import * as RootNavigation from "app/utils/RootNavigation.js";

import Value from "app/components/Value";
import Icon from "app/components/Icon";
import {
  Ionicons,
  Entypo,
  Feather,
  Octicons,
  MaterialIcons,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

export default class TimelineEvent extends React.Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    parentId: PropTypes.number,
    style: PropTypes.any,
    handleDelete: PropTypes.func,
    renderSymbols: PropTypes.bool,
    expandNote: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      expandNote: props.expandNote || false,
    };
  }

  render() {
    let { event, style, handleDelete, parentId, renderSymbols, noteOnly } =
      this.props;

    return (
      <View style={{ flex: 1 }}>
        {!noteOnly && (
          <View style={styles.wrapper}>
            <View style={[styles.item, style || null]}>
              <Text>• {this.renderDesc(event, renderSymbols)}</Text>
              {this.renderTitle(event, parentId)}
              {this.renderValue(event, parentId)}
            </View>
            {!!handleDelete && event.type == "progress" && (
              <TouchableOpacity
                onPress={() => handleDelete(event.timestamp)}
                style={{ alignSelf: "flex-end" }}
              >
                <Ionicons
                  name={"md-close"}
                  color={colors.foreground}
                  style={styles.icon}
                />
              </TouchableOpacity>
            )}
          </View>
        )}
        {this.renderNote(event)}
      </View>
    );
  }

  renderDesc = (event, renderSymbols) => {
    let { value } = this.props;
    let timestamp;
    if (!!this.props.formatTimestamp) {
      timestamp = this.props.formatTimestamp(event.timestamp);
    } else {
      timestamp = textHelpers.fullDateTime(event.timestamp);
    }
    if (!!timestamp) timestamp += ": ";
    let desc = ((type) => {
      switch (type) {
        case "progress":
          return (
            <Feather
              name={"check-circle"}
              color={colors.foreground}
              style={styles.inlineIcon}
            />
          );
        // return (new Array((event.count || 1)).fill('✓').join(''));
        case "child_completion":
          return (
            <Feather
              name={"check-circle"}
              color={colors.foreground}
              style={styles.inlineIcon}
            />
          );
        // return `✓`;
        case "milestone":
          return `Revised`;
        case "extension":
          return `Extended`;
        case "creation":
          return `Created`;
        case "completion":
          // return `[✓]`;
          return (
            <MaterialIcons
              name={"check-circle"}
              color={colors.foreground}
              style={[styles.inlineIcon]}
            />
          );
        case "archival":
          return (
            <Feather
              name={"archive"}
              color={colors.foreground}
              style={styles.inelineIcon}
            />
          );
        default:
          return "";
      }
    })(event.type);

    if (!!event.bonus_types && event.bonus_types.length > 0) {
      if (event.bonus_types.includes("progress")) {
        desc += `✓`;
      } else if (event.bonus_types.includes("completion")) {
        desc += `[✓]`;
      }
    }

    // let symbols = (renderSymbols && event.family_symbols) || ''
    // return (`${timestamp}${desc}${symbols} `)
    let icons = (renderSymbols && event.family_icons) || "";
    if (!!icons.length) {
      icons = icons.map((icon) => (
        <Icon
          name={icon}
          color={value?.color || value?.inheritedColor || event.value?.color}
          size={sizes.smallItemHeight}
        />
      ));
    }

    return (
      <Text>
        {timestamp}
        {desc}
        {icons}
      </Text>
    );
  };

  renderNote = (event, renderSymbols) => {
    let { expandNote } = this.state;

    let noteText = !!event.note?.length ? event.note.split(":")[1] : "";

    if (!!noteText) {
      return (
        <View style={styles.noteRow}>
          <Text numberOfLines={expandNote ? 999 : 1}>{noteText}</Text>
          <TouchableOpacity
            onPress={() => this.setState({ expandNote: !expandNote })}
            style={{ alignSelf: "flex-start" }}
          >
            {expandNote ? (
              <Feather
                name="chevron-up"
                color={colors.placeholder}
                style={styles.noteIcon}
              />
            ) : (
              <MaterialCommunityIcons
                name="text"
                color={colors.placeholder}
                style={styles.noteIcon}
              />
            )}
          </TouchableOpacity>
        </View>
      );
    }
  };

  renderTitle = (event, parentId = null) => {
    if (!!parentId && parentId == event.id) return null;
    // if(!!event.id && event.id != parentId && !!!event.timeline){
    if (!!!event.timeline) {
      let value = event.value || event;
      if (!!value.id)
        return (
          <Value
            hideRing
            value={value}
            // style={{borderWidth: 0, flex: 1,}}
            style={{ height: "auto" }}
            onPress={() => RootNavigation.push("Value", { id: value.id })}
          />
        );
      // return (
      //   <Text italic underline
      //     onPress={() => {
      //       let value = event.value || event
      //       let id = value.id
      //       RootNavigation.push('Value', {value, id})
      //     }}
      //   >
      //     {event.text}
      //   </Text>
      // )
    } else {
      // console.log('no title event:', !!event.id, event.id != parentId, !!!event.timeline, event)
      return null;
    }
  };

  renderValue = (event, parentId) => {
    if (parentId && parentId == event.id) return null;
    let { value } = this.props;
    // let { allValues } = this.props
    // let value = event.value || event
    // if(!!allValues && !!allValues.find(v => v.id == value.id)){
    //   value = allValues.find(v => v.id == value.id)
    // }
    // if(!!event.timeline){
    // console.log('timeline value event', event)
    return (
      <Value
        hideRing
        value={value}
        style={{ borderWidth: 0, flex: 1 }}
        onPress={() => {
          // console.log(value, event)
          RootNavigation.push("Value", { value, id: value.id });
        }}
      />
    );
    // }
    // else return null
  };
}

const styles = StyleSheet.create({
  wrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  item: {
    alignSelf: "stretch",
    flex: 1,
    // borderColor: 'blue', borderWidth: 1,
    minHeight: sizes.itemHeight,
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    marginTop: sizes.small,
    marginVertical: sizes.small,
    zIndex: -1,
    flexWrap: "wrap",
  },
  noteRow: {
    alignSelf: "stretch",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    // maxWidth: 300,
    backgroundColor: colors.fill,
    padding: sizes.base,
    padding: sizes.small,
  },
  noteIcon: {
    fontSize: 25,
    // padding: sizes.base,
    paddingHorizontal: sizes.small,
  },
  icon: {
    fontSize: 20,
    padding: sizes.base,
  },
  inlineIcon: {
    fontSize: sizes.smallItemHeight,
  },
});
